import { $request } from '@/utils/request';
import servers from '../servers';

/**
 * @description: 上传文件
 */
export function getUploadFile(params?: any): any {
  return $request({
    url: `${servers.api}/v1/common/oss/upload`,
    method: 'POST',
    data: params,
  });
}
